import { Router } from "express";

import { assignmentController } from "../controllers/assignment-controller";
import {
  authenticate,
  requireEmailVerification,
} from "../middleware/auth-middleware";
import { requireRole } from "../middleware/role-middleware";
import { uploadSubmittedFile } from "../middleware/upload-middleware";

const router = Router();

router.use(authenticate);
router.use(requireEmailVerification);
router.use(requireRole(["student"]));

/**
 * @route   GET /api/v1/student/assignments
 * @desc    Get all assignments for student's classes
 * @access  Private (Student)
 * @query   classId
 */
router.get("/", (req, res) =>
  assignmentController.getStudentAssignments(req, res),
);

/**
 * @route   GET /api/v1/student/assignments/:id/submission
 * @desc    Get student's submission for an assignment
 * @access  Private (Student)
 */
router.get("/:id/submission", (req, res) =>
  assignmentController.getStudentSubmission(req, res),
);

/**
 * @route   POST /api/v1/student/assignments/:id/submit
 * @desc    Submit assignment with files (PDF, DOC, DOCX) and/or text
 * @access  Private (Student)
 */
router.post("/:id/submit", uploadSubmittedFile, (req, res) =>
  assignmentController.submitAssignment(req, res),
);

/**
 * @route   PUT /api/v1/student/assignments/:id/resubmit
 * @desc    Re-submit assignment (update existing submission)
 * @access  Private (Student)
 */
router.put("/:id/resubmit", uploadSubmittedFile, (req, res) =>
  assignmentController.resubmitAssignment(req, res),
);

export default router;
